import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0497cea3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "¡HOLA 👋🏻!", -1))
const _hoisted_6 = { class: "login-container" }
const _hoisted_7 = { class: "notice" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "¿No tienes cuenta con nosotros?", -1))
const _hoisted_9 = { class: "modal" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " ¿No recuerdas tu email? ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " No te preocupes, indica tu DNI en el campo de email y podrás acceder directamente ", -1))
const _hoisted_12 = { class: "button" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Establecer nueva contraseña", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " Introduce tu correo electrónico y te enviaremos un enlace para que actualices tu contraseña ", -1))
const _hoisted_16 = { class: "email-not-found" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Email no registrado", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " Si el problema persiste puedes ponerte en contacto con coordinación. ", -1))
const _hoisted_20 = { class: "button" }
const _hoisted_21 = { class: "email-sent" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Email enviado", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " Mira tu bandeja de entrada y obtén el enlace para recuperar tu contraseña ", -1))
const _hoisted_24 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _component_ForgotPasswordForm = _resolveComponent("ForgotPasswordForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/images/login-background.png'),
        alt: "step1"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_LoginForm, {
          onForgotEmail: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal.forgotEmail = true)),
          onForgotPassword: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal.forgotPassword = true)),
          onClick: _ctx.loginUser,
          error: _ctx.error
        }, null, 8, ["onClick", "error"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.$route.params.planId && _ctx.$route.params.subscriptionId)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'register', params: {
            planId: _ctx.$route.params.planId,
            subscriptionId: _ctx.$route.params.subscriptionId
          } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sign up ")
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'select-plan' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sign up ")
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.modal.forgotEmail,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modal.forgotEmail) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Button, {
                  variant: "turquoise",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal.forgotEmail = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Entendido")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.modal.forgotPassword,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modal.forgotPassword) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, { class: "stretch" }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "leave",
              href: "#",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.modal.forgotPassword = false), ["prevent"]))
            }, [
              _createElementVNode("img", {
                src: require('@/assets/images/exit.svg'),
                alt: "salir"
              }, null, 8, _hoisted_13)
            ]),
            _hoisted_14,
            _hoisted_15,
            _createVNode(_component_ForgotPasswordForm, {
              onReset: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetEmail($event)))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.modal.emailNotFound,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modal.emailNotFound) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, { class: "stretch" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", {
                class: "leave",
                href: "#",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.modal.emailNotFound = false), ["prevent"]))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/exit.svg'),
                  alt: "salir"
                }, null, 8, _hoisted_17)
              ]),
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Button, {
                  variant: "turquoise",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.modal.emailNotFound = false ; _ctx.modal.forgotPassword = true})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Volver a intentarlo ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  variant: "turquoise outlined",
                  onClick: _ctx.contactSupport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Contactar con soporte ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.modal.emailSent,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modal.emailSent) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, { class: "stretch" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Button, {
                  variant: "turquoise",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.modal.emailSent = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Entendido ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}